module.exports = __webpack_public_path__ + "root-b33b72b3/XING-Sans-Bold-Italic-36a68d3c5a869c8bdf713f20b95e76d7.woff";